import { getUser } from 'src/utils/Common';
import moment from 'moment';
import axios from '../../utils/axios';


export const getTasks = ({ WorkOrderId }) => {
  // const SessionUser = getUser();
  // var ConsumerId = sessionStorage.getItem('ConsumerId');

  return axios.get(`/GetConsumerWorkOrder/${WorkOrderId}`);
};

export const GetSiriusTodaySummary = () => {
  const SessionUser = getUser();
  return axios.get(
    `/GetSiriusTodaySummary/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`
  );
};


export const getFilteredTasks = payload => {
  var normalizedStatusId = payload?.statusId.length > 0 ? payload?.statusId.map((id) => { return id.StatusId }) : 0;
  var normalizedStartDate = moment(payload.startDate).format('YYYY-MM-DD');
  var normalizedEndDate = moment(payload.endDate).format('YYYY-MM-DD');
  return axios.get(
    `/GetTasksDataDetail/${payload.serviceShopId}/${normalizedStatusId.toString()}/${normalizedStartDate}/${normalizedEndDate}/${payload.openCase}/${payload.openDay}`
  )
}